import React, { Component } from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import Backend from '../../Backend';
import ReCAPTCHA from "react-google-recaptcha";
import { Bounce } from 'react-activity';
import ReactFlagsSelect from 'react-flags-select';
import Countries from '../../Countries';
import ReactNotification from 'react-notifications-component';
import Connection from '../../Calls';
import { store } from 'react-notifications-component';
import './index.css';
import countries from '../Select/countryOptions';
import SelectCountry from '../Select/SelectCountries';

import es from '../../translate/es'
import en from '../../translate/en'

var countryForgot;

class LoginIndex extends Component {
  constructor(props) {
    super(props)
    this.state = {
      reCaptcha: '',
      countryForgot: '',
      showLoadForgot: false,
      emailForgot: '',
      text:en
    }
  }

  componentWillMount() {
    this.bQk7VZx7();
    this.listenerStorage()
  }

  listenerStorage(){
    const self =this;
    var originalSetItem = localStorage.setItem;
    localStorage.setItem = function(){
      document.createEvent('Event').initEvent('itemInserted', true, true);
      originalSetItem.apply(this, arguments);
      if(localStorage.getItem('lan')=='es')self.setState({text:es})
      else self.setState({text:en})
    }

    if(localStorage.getItem('lan')=='es')this.setState({text:es})
      else this.setState({text:en})

  }

  bQk7VZx7() {
    const self = this;
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XJPW023"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.bQk7VZx7(confirmation, date, result, "Bm3h642", combination, "XJPW023", response => {
      self.setState({
        vertice: response.payload.r03
      })
    });
  }

  handleChange(value) {
    if (value !== null) {
      this.setState({ reCaptcha: "confirmed" });
    }
  }

  onSelectFlag({label}) {
    countryForgot = label;
  }

  forgotFunc() {
    const self = this;
    self.setState({ showLoadForgot: true });
    if (this.state.emailForgot !== "" && countryForgot !== "") {
      if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.state.emailForgot) !== false) {
        if (this.state.reCaptcha !== "") {
          let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XWBX203"), latitude = "0", longitude = "0";
          let whiskas = Connection.RThzHrsb(self.state.emailForgot);
          navigator.geolocation.getCurrentPosition((success, error, options) => {
            latitude = success.coords.latitude;
            longitude = success.coords.longitude
          });
          result = latitude + longitude;

          Connection.QCJQ7DUk(confirmation, date, result, "Apxm2aZ", combination, "XWBX203", "1", whiskas, response => {
            Backend.Forgot(self.state.emailForgot, countryForgot, response.payload.r03, self.state.reCaptcha, response => {
              if (response.status.code === "0") {
                store.addNotification({
                  title: "Success!",
                  message: response.payload.message,
                  type: "success",
                  insert: "top",
                  container: "top-right",
                  animationIn: ["animated", "fadeIn"],
                  animationOut: ["animated", "fadeOut"],
                  dismiss: {
                    duration: 1800,
                    onScreen: true
                  }
                });
                self.setState({ emailForgot: '', countryForgot: '', reCaptcha: '', showLoadForgot: false });
                this.props.handleCloseForgot();
              } else {
                store.addNotification({
                  title: "Error!",
                  message: response.status.description,
                  type: "danger",
                  insert: "top",
                  container: "top-right",
                  animationIn: ["animated", "fadeIn"],
                  animationOut: ["animated", "fadeOut"],
                  dismiss: {
                    duration: 1800,
                    onScreen: true
                  }
                });
                self.setState({ showLoadForgot: false });
              }
            });
          });
        } else {
          store.addNotification({
            title: "Error!",
            message: "Verify the captcha",
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
          self.setState({ showLoadForgot: false });
        }
      } else {
        store.addNotification({
          title: "Error!",
          message: "Email is bad formmated",
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 1800,
            onScreen: true
          }
        });
        self.setState({ showLoadForgot: false });
      }
    } else {
      store.addNotification({
        title: "Error!",
        message: "Verify information, fields cannot be empty",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true
        }
      });
      self.setState({ showLoadForgot: false });
    }
  }

  render() {
    return (
      <div>
        <Modal className="modal-signup-resend-email" aria-labelledby="contained-modal-title-vcenter" centered show={this.props.showModalForgot} onHide={() => { this.props.handleCloseForgot() }}>
          <Modal.Body>
            <div className="border-title-separator-container">
              <div className="border-title-separator-container-left" style={{ width: "100%" }}>
                <p className="title-login">{this.state.text.Forgot.title}</p>
              </div>
            </div>
            <div>
              <Form.Group>
                <Form.Label className="label-forgot">{this.state.text.Forgot.L_mail}</Form.Label>
                <center>
                  <Col sm="12">
                    <Form.Control
                      type="email"
                      // placeholder={this.state.text.Forgot.P_mail}
                      className="input-signup"
                      value={this.state.emailForgot}
                      onChange={(emailForgot) => { this.setState({ emailForgot: emailForgot.target.value }) }}
                    />
                  </Col>
                </center>
              </Form.Group>
              {/* <Form.Group>
                <Form.Label className="label-forgot">{this.state.text.Forgot.L_Country}</Form.Label>
                <center>
                  <Col sm="12">
                    <ReactFlagsSelect
                      className="input-signup form-control"
                      searchable={true}
                      placeholder=""
                      searchPlaceholder="Search for a country"
                      value={this.state.country}
                      onSelect={this.onSelectFlag}
                    />
                  </Col>
                </center>
              </Form.Group> */}
              <Form.Group>
                <Form.Label className="label-forgot">{this.state.text.Forgot.L_Country}</Form.Label>
                  <Col sm="12">
                    <SelectCountry
                      options={countries}
                      isSearchable={true}
                      value={this.state.country}
                      onChange={this.onSelectFlag}
                    />
                  </Col>
              </Form.Group>
              <div>
                <center style={{ marginBottom: 0 }}>
                  {
                    (this.state.vertice) &&
                    <ReCAPTCHA
                    theme="light"
                    sitekey={this.state.vertice}
                    onChange={this.handleChange.bind(this)}
                  />
                  }
                </center>
              </div>
              <div>
                <div style={{ marginTop: 30, textAlign: "center" }}>
                  <Button className="btn-resend-email" variant="primary" onClick={() => { this.forgotFunc() }} disabled={this.state.showLoadForgot}>
                    {
                      (this.state.showLoadForgot)
                        ? <Bounce size={20} color={"#FFFFFF"} animating={this.state.showLoadForgot} />
                        : this.state.text.Forgot.btn
                    }
                  </Button>
                </div>
                <div style={{ marginTop: 0, textAlign: "center" }}>
                  <Button className="label-link" variant="link" onClick={() => { this.props.handleReturnLogin() }}>{this.state.text.Forgot.link_Forgot}</Button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

      </div>
    );
  }
} export default LoginIndex;
